import { cn } from '@/lib/utils';

export type KbdProps = React.ComponentProps<'kbd'>;

export function Kbd({ className, children, ...props }: KbdProps) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center gap-0.5 rounded-sm border border-border bg-muted px-1 font-sans text-[11px] font-medium leading-none text-muted-foreground shadow-inner-sm',
        className,
      )}
      {...props}
    >
      {children}
    </kbd>
  );
}
